export const ACTION_LOADING_MESSAGE_KEY = 'commerceContractLib.actions.loading.tooltip';

/** @deprecated use COMMON_VALIDATION_ERRORS from commerce-contract-lib/features/actions/hooks/useCommonValidation instead */
export { COMMON_VALIDATION_ERRORS } from '../hooks/useCommonValidation';